<template>
  <v-card>
    <v-card-text>
      <empty-section title="Історія відсутня" />
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import EmptySection from '@/components/EmptySection.vue'

export default {
  name: 'ContractorHistoryTab',
  components: { EmptySection },
}
</script>
